module.exports = __webpack_public_path__ + "img/collectNone.70774e77.png";